import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    selector: "dtm-main-page-lib-dss",
    templateUrl: "./dss-subpage.component.html",
    styleUrls: ["../shared.scss", "dss-subpage.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DssSubpageComponent {}
